import { fieldError } from '../fieldError';

export function checkMinLength(minLengthValue) {
  return value =>
    value.length < minLengthValue
      ? fieldError(`Insira no mínimo ${minLengthValue} caracteres`)
      : null;
}
